// 2023-11-28 - moved from formsviewer.domain.js

// ============
// DefaultValue
// ============
function DefaultValue(target, expression, refresh) {
    this.getTarget = function () {
        return target;
    };
    this.getExpression = function () {
        return expression;
    };
    this.getRefresh = function () {
        return refresh;
    };
}

export default DefaultValue;
